import React from "react"
import { toastr } from "react-redux-toastr"
import { $myFetch } from "."
import { ISupplierReference, ITranslations } from "../../models"
import { Roles } from "../../utils"
import { stringify } from "../../utils/stringifyier"

export const $getMultiModifProductList = (
  droopyIds: string[],
  supplierName: string
): Promise<ISupplierReference[]> => {
  const myHeaders = new Headers()
  return $myFetch(
    `product/GetMultiModifProductList`,
    {
      headers: myHeaders,
    },
    [{ key: "ids", value: droopyIds.join(";") }],
    undefined,
    supplierName
  ).then((res) => res.json())
}

export const $sendMultiModifPriceInformations = (
  data: { droopyId: string; newPrice: number }[],
  role: Roles,
  supplierName: string,
  translations: ITranslations["productList"]
): Promise<any> => {
  const myHeaders = new Headers()
  myHeaders.append("Content-Type", "application/json")
  toastr.message(translations.longRequestToastrHeader, "", {
    component: (
      <>
        <p>{translations.longRequestToastrBodyOne}</p>
        <p>{translations.longRequestToastrBodyTwo}</p>
      </>
    ),
  })
  return $myFetch(
    "product/multiPrices",
    {
      body: JSON.stringify(data),
      headers: myHeaders,
      method: "POST",
    },
    [],
    role,
    supplierName
  ).then((res) => {
    toastr.removeByType("message")
    toastr.info(translations.multiModifUpdateSuccess, "", {
      showCloseButton: true,
      timeOut: 25000,
    })
    return res
  })
}

export const $sendMultiModifInformations = (
  droopyIds: string[],
  declinedDroopyIds: string[],
  form: FormData,
  translations: ITranslations["productList"]
): Promise<any> => {
  toastr.message(translations.longRequestToastrHeader, "", {
    component: (
      <>
        <p>{translations.multiModifSubmitBodyOne}</p>
        <p>{translations.multiModifSubmitBodyTwo}</p>
      </>
    ),
  })

  const myHeaders = new Headers()
  myHeaders.append("enctype", "multipart/form-data")
  droopyIds.forEach((id) => {
    form.append(`droopyIds`, id)
  })
  declinedDroopyIds.forEach((id) => {
    form.append(`declinedDroopyIds`, id)
  })

  return $myFetch("product/multi", {
    body: form,
    headers: myHeaders,
    method: "POST",
  }).then((res) => {
    toastr.removeByType("message")
    toastr.info(translations.multiModifUpdateSuccess, "", {
      showCloseButton: true,
      timeOut: 25000,
    })
    return res
  })
}
